export default __webpack_public_path__ + "static/media/introduction-bg.4747682b.png";